// Keep destination query parameters and fragments while forwarding campaign attribution.
export function withQuery(link, queryString = '') {
  if (!link) return ''
  try {
    const url = new URL(link)
    if (!['https:', 'http:'].includes(url.protocol)) return ''
    new URLSearchParams(queryString).forEach((value, key) => url.searchParams.set(key, value))
    return url.toString()
  }
  catch (_) {
    return ''
  }
}

export function officialLink(logoURL, locale, queryString = '', path = '') {
  if (!logoURL) return ''
  try {
    const url = new URL(logoURL)
    const language = supportedLocale(locale) === 'zh-CN' ? '' : '/zh-TW'
    url.pathname = `${url.pathname.replace(/\/$/, '')}${language}${path}` || '/'
    return withQuery(url.toString(), queryString)
  }
  catch (_) {
    return ''
  }
}

export function isDesktopBrowser(navigator, width) {
  const agent = navigator.userAgent || ''
  if (navigator.userAgentData?.mobile || /Android|iPhone|iPad|iPod|Mobile/i.test(agent)) return false
  // iPadOS uses a desktop user agent; it must remain on minisite.
  if (/Macintosh/i.test(agent) && navigator.maxTouchPoints > 1) return false
  if (/Windows NT|Macintosh|X11|CrOS/i.test(agent)) return true
  return width > 1024
}

export function androidGames(games) {
  return games.filter(game => Array.isArray(game.supportPlatforms) &&
    game.supportPlatforms.some(platform => String(platform).toLowerCase() === 'android'))
}

let selectedLocale = ''

// English content is temporarily unavailable. Keep translation files for later.
export function supportedLocale(locale) {
  return locale === 'zh-CN' ? 'zh-CN' : 'zh-TW'
}

export function standaloneImageUrl(image, resizeBase = 'https://imgdl.h365.games') {
  if (!image) return ''
  try {
    const url = new URL(image)
    if (!['http:', 'https:'].includes(url.protocol)) return ''
    // The catalog still returns retired image hosts. Use the same image service
    // and asset path as the official portal, without rewriting unrelated images.
    if (url.pathname.startsWith('/official-website-asset/'))
      return `${resizeBase.replace(/\/$/, '')}/440${url.pathname}?fm=webp&q=80`

    return url.toString()
  }
  catch (_) { return '' }
}

export function rememberLocale(locale) {
  selectedLocale = locale ? supportedLocale(locale) : ''
  try { window.sessionStorage.setItem('minisite-locale', selectedLocale) }
  catch (_) { /* Keep the choice in memory when browser storage is unavailable. */ }
}

export function configurationLocale(configLocale) {
  try { selectedLocale = selectedLocale || window.sessionStorage.getItem('minisite-locale') || '' }
  catch (_) { /* Storage is optional. */ }
  return supportedLocale(selectedLocale || configLocale)
}